import { connect } from "react-redux";
import get from "lodash/get";

import { newNotification as onNewNotification, stateNotificatio as onStateNotification } from "../../actions/notificationsActions";

const mapStateToProps = (state) => ({
  notifications: get(state, ["notifications", "notifications"], []),
});

const mapDispatchToProps = { onNewNotification, onStateNotification };

const withNotifications = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withNotifications };
